export const BREAK_XS = 576;
export const BREAK_S = 768;
export const BREAK_M = 1024;
export const SITE_MAX_WIDTH = 1200;
export const SITE_HEIGHT_LARGE = 1200;
